import { NavTabPartialProps } from "@/components/custom/tabs/nav-tabs";
import { ScrollArea } from "@/components/ui/scroll-area";
import { UserTabs } from "./-user-tabs";

export function Layout({
  children,
  tabs,
}: {
  children?: React.ReactNode;
  tabs?: NavTabPartialProps;
}) {
  return (
    <UserTabs padding={false} {...tabs}>
      <ScrollArea
        viewport={{ className: "pt-3 h-lg:pt-4" }}
        className="-mr-4 pr-4 h-full"
      >
        {children}
      </ScrollArea>
    </UserTabs>
  );
}
